module.exports = __webpack_public_path__ + "img/aws.a3451d78.png";